/** Count committed keys, never progress callbacks or video buffers. Failure is unknown, not zero. */
export async function observeDurablePreparation(readCount: () => Promise<number>): Promise<Record<string, unknown>> {
	let timer: ReturnType<typeof setTimeout> | undefined;
	try {
		const result = await Promise.race([
			Promise.resolve().then(readCount),
			new Promise<"timed-out">((resolve) => {
				timer = setTimeout(() => resolve("timed-out"), 750);
			})
		]);
		return result === "timed-out"
			? { durableCountStatus: result, durableCountObservedAt: Date.now() }
			: {
					durableCountStatus: "observed",
					durableChunkCount: result,
					durableCountBasis: "chunk-data-keys",
					durableCountObservedAt: Date.now()
				};
	} catch {
		return { durableCountStatus: "unavailable", durableCountObservedAt: Date.now() };
	} finally {
		clearTimeout(timer);
	}
}
